import React from 'react';

import { Box, Typography, Card } from '@iclinic/design-system';
import { patientHistorySelector } from '../state/selectors';
import useStyles from './Header.style';

interface HeaderCardProps {
  section: ReturnType<typeof patientHistorySelector>[number];
  onClick: () => void;
}

export const HeaderCard = ({ section, onClick }: HeaderCardProps) => {
  const classes = useStyles();
  const { title, observation } = section;

  return (
    <Card
      key={section.id}
      variant="outlined"
      className={classes.card}
      onClick={onClick}
    >
      <Box>
        <Typography className={classes.section}>{title}</Typography>
        <Typography className={classes.observation}>{observation}</Typography>
      </Box>
    </Card>
  );
};
